<template>
  <v-treeview
    activatable
    :items="items"
    item-key="id"
    @update:active="onChange"
  >
    <template #prepend="{ item }">
      <v-icon
        size="30"
        class="hover-effect"
        >{{ getIcon(item) }}</v-icon
      >
    </template>

    <template #label="{ item }">
      <div class="font-weight-medium hover-effect">{{ getName(item) }}</div>
      <div class="text-caption text-disabled d-flex justify-space-between hover-effect">
        {{ getDatetime(item) }}
        <div class="ml-auto hover-result">
          <v-btn
            icon
            color="secondary"
            x-small
            v-if="getDatetime(item)"
            @click.stop="openRename(item)"
            :spantext="$t('actions.edit', { entity: $tc('commons.folder', 1).toLowerCase() })"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </div>
      </div>
    </template>
  </v-treeview>
</template>

<script>
import { toDatetime } from "@/utils/datetime"
// import { capitalizeText } from "@/utils/string"

export default {
  name: "FolderList",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    items() {
      const tree = this.buildTree(this.value)
      return tree
    }
  },
  data() {
    return { selected: null }
  },
  methods: {
    buildTree(data) {
      const map = new Map()

      data.forEach((item, idx) => {
        const parts = item.name.split("/")
        const folderName = parts[parts.length - 1]
        let newName = folderName

        // Conditions pour changer le nom des dossiers spécifiques
        if (folderName.toLowerCase() === "reports") {
          newName = this.$t("views.documentation.report")
        } else if (folderName.toLowerCase() === "non-conformities") {
          newName = this.$t("views.documentation.non_conformities")
        } else if (folderName.toLowerCase() === "medias") {
          newName = this.$t("views.documentation.medias")
        } else if (folderName.toLowerCase() === "inspections") {
          newName = this.$t("views.documentation.inspections")
        } else if (folderName.toLowerCase() === "pcq-dsi") {
          newName = this.$t("views.documentation.pcq_dsi")
        }

        const itemData = {
          id: idx,
          name: newName,
          updated_at: item.updated_at,
          children: [],
          isLocked: !item.id,
          originalPath: item.name // Garde la trace du chemin original
        }

        map.set(itemData.originalPath, itemData)

        if (parts.length === 1) {
          // Dossier racine
          itemData.parent = null
        } else {
          // Sous-dossier
          const parentPath = parts.slice(0, parts.length - 1).join("/")
          const parentItem = map.get(parentPath)
          if (parentItem) {
            itemData.parent = parentItem.id
            parentItem.children.push(itemData)
          }
        }
      })

      // Filtrer les racines
      const roots = Array.from(map.values()).filter(item => !item.parent)

      return roots
    },
    getDatetime(item) {
      return item.updated_at ? toDatetime(item.updated_at) : ""
    },
    getIcon(item) {
      if (this.selected === item.id) {
        return "mdi-folder-open"
      } else if (item.isLocked) {
        return "mdi-folder-lock"
      } else {
        return "mdi-folder"
      }
    },
    getName(item) {
      if (item.name != "ITP") {
        // return capitalizeText(item.name)
        return item.name
      }
      return item.name
    },
    onChange(values) {
      this.selected = values[0]
      this.$emit("hasChanged", this.selected)
    },
    openRename(item) {
      this.selected = item
      this.$emit("toRename", this.selected)
    }
  }
}
</script>

<style scoped>
.hover-result {
  display: none;
}
.hover-effect:hover .hover-result {
  display: block;
}
</style>
